import React from "react";

import PieChartSvg from "../../assets/images/icons/Form Controls/Pie-Ring Chart.svg";

export const PieChartIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={PieChartSvg}
        alt={alt || "PieChart"}
    />
);
